import { Form, Spin } from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { UserService } from "../../services/user/UserService";
import { handleError } from "../../utils/ErrorHandlers";
import UsersList from "./UsersList";
import Page from "../general/Page";
import "./User.css";
import { Translation } from "react-i18next";
import { Constants } from "../../data/constants";
class Users extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("users");
    this.state = {
      isFetching: false,
      data: [],
      // cfgData: [],
      visible: false,
      loading: false,
      accountType: this.props.context.user.userType,
      accountId:this.props.context.user.accountId
    };
        this.userService = new UserService();
    this.constants =  new Constants();
  }

  componentDidMount() {
    this.state.accountType === this.constants.userTypeList.super ||  this.state.accountType === this.constants.userTypeList.customerCare
      ? this.viewAllUsersByAccountId()
      : this.getAllUsers();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }
  async viewAllUsersByAccountId() {
    let { id } = this.props.match.params;
    try {
      this.setState({ isFetching: true });
      let data = await this.userService.viewAllUsersByAccountId(
        this.props.context.session_id,
        id
      );

      // this.setState({
      //   data: data.ivrList,
      //   isFetching: false,
      //   cfgData: data.cfgList,
      // });
      this.userDataAndCfgMapping(data.ivrList, data.cfgList);
    } catch (e) {
      this.setState({ isFetching: false });

      handleError(e);
    }
  }
  async getAllUsers() {
    try {
      this.setState({ isFetching: true });

      let data = await this.userService.getAllUsersByAccountIdService(
        this.props.context.session_id,
        this.props.context.user.accountId
      );

      // this.setState({
      //   data: data.ivrList,
      //   isFetching: false,
      //   cfgData: data.cfgList,
      // });
      this.userDataAndCfgMapping(data.ivrList, data.cfgList);
    } catch (e) {
      this.setState({ isFetching: false });

      handleError(e);
    }
  }

  cfgFormatting(cfgfiltered) {
    // change the formatting of property
    let cfgFormatted = {};
    cfgFormatted.accountId = "";
    cfgFormatted.userId = "";
    cfgFormatted.configCategory = "";
    cfgFormatted.agentStatus = "";
    cfgFormatted.agentNumber = "";
    cfgfiltered.forEach((el, index) => {
      if (el.key === "AGENT_STATUS") {
        cfgFormatted.agentStatus = el.value;
        cfgFormatted.accountId = el.accountId;
        cfgFormatted.configCategory = el.configCategory;
        cfgFormatted.userId = el.userId;
      }
      if (el.key === "AGENT_NUMBER") {
        cfgFormatted.agentNumber = el.value;
        cfgFormatted.accountId = el.accountId;
        cfgFormatted.configCategory = el.configCategory;
        cfgFormatted.userId = el.userId;
      }
    });
    return cfgFormatted;
  }

  // userDataAndCfgMapping(data, cfgData) {
  //   //let { data, cfgData } = this.state;
  //   //get an array of data and cfg
  //   data.forEach((element, index) => {
  //     let cfgtest = cfgData.filter(
  //       (cfgEl) =>
  //         element.accountId === cfgEl.accountId &&
  //         element.userId === cfgEl.userId
  //     );
  //     data[index].cfg = this.cfgFormatting(cfgtest);
  //     data[index].agentStatus = data[index].cfg.agentStatus;
  //   });

  //   this.setState({ data: data, isFetching: false });
  // }

  userDataAndCfgMapping(data, cfgData) {
  const filteredData = data.filter(element => element.userType !== "GUEST");

  const updatedData = filteredData.map(element => {
    const cfgtest = cfgData.filter(
      (cfgEl) =>
        element.accountId === cfgEl.accountId &&
        element.userId === cfgEl.userId
    );

    return {
      ...element,
      cfg: this.cfgFormatting(cfgtest),
      agentStatus: this.cfgFormatting(cfgtest).agentStatus 
    };
  });

  this.setState({ data: updatedData, isFetching: false });
}

  showCreateUserForm = () => {
    let { history } = this.props;
    history.push("/home/users/create/" + this.props.context.user.accountId);
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  render() {
    let { isFetching } = this.state;

    return (
      <Translation>
        {(t) => (
          <Page
            title={t("Users")}
            hasBackArrow={    this.state.accountType === this.constants.userTypeList.super ||  this.state.accountType === this.constants.userTypeList.customerCare
              ? true : false}
          >
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                {/* <Button
              className="button-add-account"
              onClick={this.showCreateUserForm}
              icon="plus"
            />
            <span>Add User</span> */}

                <UsersList
                  data={this.state.data}
                  onRefresh={() =>
                    this.state.accountType === this.constants.userTypeList.super ||  this.state.accountType === this.constants.userTypeList.customerCare
                    ? this.viewAllUsersByAccountId()
                      : this.getAllUsers()
                  }
                  accountType={this.state.accountType}
                  accountId={this.state.accountId}
                ></UsersList>
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(withSharedStateConsumer(withRouter(Users)));
